import i18next from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS: 'admin',
    ns: [
      'admin',
      'orders',
      'licences',
      'systems',
      'settings',
      'menu',
      'notification',
      'guest'
      ],
    fallbackLng: ['en'],
    debug: false,
    backend: {
      lng: ['cs', 'en'],
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      crossDomain: true
    }
  });

export default i18next;